import styled from "styled-components"
import { Link } from "gatsby"
export const Block = styled.div`
  display: flex;
  /* height: 90vh; */
  text-align:justify;
  .col1 {
    flex-basis: 60%;

  }
  .col2 {
    align-self: center;
    padding: 4rem;
    flex-basis: 40%;
    max-width: 30rem;
    text-align:justify;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .row1 {
    text-align: center;
    h3 {
      font-size: ${({ theme }) => theme.fontsize.large};
      margin-top: 0;
    }
    p {
      font-weight: bold;
    }
  }
  .row2 {
    & > div {
      margin-bottom: 0.5rem;
    }
    h4 {
      display: inline-block;
      margin-bottom: 0;
      font-family: "Aller";
    }
    .box__btn {
      text-align: center;
    }
    .arrow-right {
      margin-right: 10px;
      font-weight: bold;
    }
  }

  @media (max-width: 800px) {
    flex-direction: column;
    height: auto;
    /* height: auto; */
    .col1,
    .col2 {
      flex-basis: auto;
    }
    .col1 {
      /* height: 20vh; */
    }
    .col2 {
      /* height: 80vh; */
      max-width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;

      /* display: flex; */
      /* flex-direction: column; */
      /* justify-content: center; */
    }
  }
  @media (max-width: 500px) {
    .col2 {
      padding: 1.2rem 3rem;
    }
  }
`
// píldora amarilla como en el Canva; el hover solo agranda, sin cambiar colores
export const Btn = styled(Link)`
  display: inline-flex;
  align-items: center;
  padding: 10px 28px;
  border-radius: 30px;
  font-weight: bold;
  font-size: 1.1rem;
  text-decoration: none;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.blanco};
  background-color: ${({ theme }) => theme.colors.amarillo};
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.35);
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.35);
  transition: transform 0.3s, box-shadow 0.3s;
  :hover {
    color: ${({ theme }) => theme.colors.blanco};
    transform: scale(1.1);
    box-shadow: 0 8px 18px rgba(0, 0, 0, 0.45);
  }
`
export const BlockWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.azul};
  color: ${({ theme }) => theme.colors.blanco};
  & + & {
    border-top: 1px solid rgba(255, 255, 255, 0.15);
  }
  h3 {
    color: ${({ theme }) => theme.colors.blanco};
  }
  .row1 p {
    font-weight: normal;
    text-align: center;
  }
`
